import {
  CommonBannerHeroSection,
  StartYourBusinessFacilityOptionsSection,
  StartYourBusinessFieldCardsSection,
  StartYourBusinessInfoSection,
  StartYourBusinessRegisterProcessSection,
} from "@/components";
import React from "react";

const StartYourBusinessPageCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  return (
    <>
      {/* Banner Section */}
      {selectedTab === "section-1" && (
        <CommonBannerHeroSection
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
          imageInputFieldLabel="Banner Image"
          imageInputFieldKeyName="start-your-business-section-1-banner-image"
          headingInputFieldLabel="Heading"
          headingInputFieldKeyName="start-your-business-section-1-heading"
          subHeadingInputFieldLabel="Sub Heading"
          subHeadingInputFieldKeyName="start-your-business-section-1-sub-heading"
        />
      )}

      {/* Info Section */}
      {selectedTab === "section-2" && (
        <StartYourBusinessInfoSection
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* Fields Card Section */}
      {selectedTab === "section-3" && (
        <StartYourBusinessFieldCardsSection
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
          handleTextEditorInputChange={handleTextEditorInputChange}
        />
      )}

      {/* Facility Options Section */}
      {selectedTab === "section-4" && (
        <StartYourBusinessFacilityOptionsSection
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
          handleTextEditorInputChange={handleTextEditorInputChange}
        />
      )}

      {/* Register Process Section */}
      {selectedTab === "section-5" && (
        <StartYourBusinessRegisterProcessSection
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}
    </>
  );
};

export default StartYourBusinessPageCMSForm;
